import libphonenumber from 'google-libphonenumber';

const DEFAULT_PHONE_REGION = 'DE';

const MIN_PHONE_DIGITS = 7;
const MAX_PHONE_DIGITS = 15;

export const detectPhoneNumber = (candidate: string): string | null => {
  const unwrapped = candidate.startsWith('(') ? candidate.slice(1) : candidate;

  if (!unwrapped.startsWith('+') && !unwrapped.startsWith('0')) {
    return null;
  }

  const digitCount = candidate.replace(/\D/g, '').length;

  if (digitCount < MIN_PHONE_DIGITS || digitCount > MAX_PHONE_DIGITS) {
    return null;
  }

  try {
    const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
    const parsed = phoneUtil.parseAndKeepRawInput(candidate, DEFAULT_PHONE_REGION);

    if (!phoneUtil.isValidNumber(parsed)) {
      return null;
    }

    return phoneUtil.format(parsed, libphonenumber.PhoneNumberFormat.E164);
  } catch (_) {
    return null;
  }
};
